import gql from 'graphql-tag';

const DELETE_PROSPECT_APPOINTMENT = gql` 
  mutation deleteProspectAppointment($input: ProspectAppointmentDeleteInput!, $sendEmail: Boolean!) {
    deleteProspectAppointment(input: $input, sendEmail: $sendEmail) {
      message
      code
    }
  }
`;

export default DELETE_PROSPECT_APPOINTMENT;